jQuery(document).ready(function ($) {
  $("#maps").tooltip("toggle");
});
